import type { MailboxInfo } from 'owa-client-types';
import type NewMailNotificationPayload from 'owa-service/lib/contract/NewMailNotificationPayload';
import { action } from 'satcheljs';

export interface NEW_MAIL_NOTIFICATIONActionMessage {
    notification: NewMailNotificationPayload;
    mailboxInfo: MailboxInfo | undefined;
}
const defaultExport: (
    notification: NewMailNotificationPayload,
    mailboxInfo?: MailboxInfo
) => NEW_MAIL_NOTIFICATIONActionMessage = action(
    'NEW_MAIL_NOTIFICATION',
    (
        notification: NewMailNotificationPayload,
        mailboxInfo?: MailboxInfo
    ): NEW_MAIL_NOTIFICATIONActionMessage => ({
        notification,
        mailboxInfo,
    })
);
export default defaultExport;
